import React, { useState, useEffect } from "react";
import { showSuccess, showError } from "component/utils/SweetAlert";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import axios from "axios";

export default function FormEmployee({ user, mode, employeeData, onBack, onSuccess }) {
  const [originalData, setOriginalData] = useState(null);
  const [formData, setFormData] = useState({
    NIK: "",
    NAMA_LENGKAP: "",
    JENIS_KELAMIN: "",
    AGAMA: "",
    TEMPAT_LAHIR: "",
    TANGGAL_LAHIR: "",
    PENDIDIKAN: "",
    ALAMAT: "",
    NO_HP: "",
    EMAIL: "",
    JABATAN: "",
    DEPARTEMEN: "",
    TANGGAL_MASUK: "",
    TANGGAL_KELUAR: "",
    STATUS_KARYAWAN: "",
    NO_BPJS_KES: "",
    NO_BPJS_KETENAGAKERJAAN: "",
    KONTAK_DARURAT_NAMA: "",
    KONTAK_DARURAT_HP: "",
    BANK_NAMA: "",
    BANK_NO_REKENING: "",
    BANK_ATAS_NAMA: "",
    image: null,
    entry_by: user?.name,
    reg_desc: user?.company,
  });

  useEffect(() => {
    if (mode === "edit" && employeeData) {
      const data = {
        ...employeeData,
        image: employeeData.FOTO
      };

      setFormData(data);
      setOriginalData(data);
    }
  }, [mode, employeeData]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const appendIfChanged = (form, key, newValue, oldValue) => {

    const newVal = newValue ?? "";
    const oldVal = oldValue ?? "";

    if (String(newVal) !== String(oldVal)) {
      form.append(key, newVal);
    }

  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (mode === "add") {

        const data = new FormData();

        data.append("NIK", formData.NIK);
        data.append("NAMA_LENGKAP", formData.NAMA_LENGKAP);
        data.append("JENIS_KELAMIN", formData.JENIS_KELAMIN);
        data.append("AGAMA", formData.AGAMA);
        data.append("PENDIDIKAN", formData.PENDIDIKAN);
        data.append("TEMPAT_LAHIR", formData.TEMPAT_LAHIR);
        data.append("TANGGAL_LAHIR", formData.TANGGAL_LAHIR);
        data.append("ALAMAT", formData.ALAMAT);
        data.append("NO_HP", formData.NO_HP);
        data.append("EMAIL", formData.EMAIL);
        data.append("JABATAN", formData.JABATAN);
        data.append("DEPARTEMEN", formData.DEPARTEMEN);
        data.append("TANGGAL_MASUK", formData.TANGGAL_MASUK);
        data.append("STATUS_KARYAWAN", formData.STATUS_KARYAWAN);

        data.append("NO_BPJS_KES", formData.NO_BPJS_KES || "");
        data.append("NO_BPJS_KETENAGAKERJAAN", formData.NO_BPJS_KETENAGAKERJAAN || "");
        data.append("KONTAK_DARURAT_NAMA", formData.KONTAK_DARURAT_NAMA || "");
        data.append("KONTAK_DARURAT_HP", formData.KONTAK_DARURAT_HP || "");
        data.append("BANK_NAMA", formData.BANK_NAMA || "");
        data.append("BANK_NO_REKENING", formData.BANK_NO_REKENING || "");
        data.append("BANK_ATAS_NAMA", formData.BANK_ATAS_NAMA || "");

        data.append("entry_by", formData.entry_by);
        data.append("reg_desc", formData.reg_desc);

        if (formData.image instanceof File) {
          data.append("image", formData.image);
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API}/add-employee`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status === 201) {
          showSuccess("Karyawan berhasil ditambahkan");
          onBack();
          if (onSuccess) onSuccess();
        } else {
          showError("Gagal menambahkan karyawan");
        }

      } else {

        const data = new FormData();

        data.append("KARYAWAN_ID", formData.KARYAWAN_ID);
        appendIfChanged(data,"NIK",formData.NIK,originalData.NIK);
        appendIfChanged(data,"NAMA_LENGKAP",formData.NAMA_LENGKAP,originalData.NAMA_LENGKAP);
        appendIfChanged(data,"JENIS_KELAMIN",formData.JENIS_KELAMIN,originalData.JENIS_KELAMIN);
        appendIfChanged(data,"AGAMA",formData.AGAMA,originalData.AGAMA);
        appendIfChanged(data,"PENDIDIKAN",formData.PENDIDIKAN,originalData.PENDIDIKAN);
        appendIfChanged(data,"TEMPAT_LAHIR",formData.TEMPAT_LAHIR,originalData.TEMPAT_LAHIR);
        appendIfChanged(data,"TANGGAL_LAHIR",formData.TANGGAL_LAHIR,originalData.TANGGAL_LAHIR);
        appendIfChanged(data,"ALAMAT",formData.ALAMAT,originalData.ALAMAT);
        appendIfChanged(data,"NO_HP",formData.NO_HP,originalData.NO_HP);
        appendIfChanged(data,"EMAIL",formData.EMAIL,originalData.EMAIL);
        appendIfChanged(data,"JABATAN",formData.JABATAN,originalData.JABATAN);
        appendIfChanged(data,"DEPARTEMEN",formData.DEPARTEMEN,originalData.DEPARTEMEN);
        appendIfChanged(data,"TANGGAL_MASUK",formData.TANGGAL_MASUK,originalData.TANGGAL_MASUK);
        appendIfChanged(data,"TANGGAL_KELUAR",formData.TANGGAL_KELUAR,originalData.TANGGAL_KELUAR);
        appendIfChanged(data,"STATUS_KARYAWAN",formData.STATUS_KARYAWAN,originalData.STATUS_KARYAWAN);

        appendIfChanged(data,"NO_BPJS_KES",formData.NO_BPJS_KES,originalData.NO_BPJS_KES);
        appendIfChanged(data,"NO_BPJS_KETENAGAKERJAAN",formData.NO_BPJS_KETENAGAKERJAAN,originalData.NO_BPJS_KETENAGAKERJAAN);
        appendIfChanged(data,"KONTAK_DARURAT_NAMA",formData.KONTAK_DARURAT_NAMA,originalData.KONTAK_DARURAT_NAMA);
        appendIfChanged(data,"KONTAK_DARURAT_HP",formData.KONTAK_DARURAT_HP,originalData.KONTAK_DARURAT_HP);
        appendIfChanged(data,"BANK_NAMA",formData.BANK_NAMA,originalData.BANK_NAMA);
        appendIfChanged(data,"BANK_NO_REKENING",formData.BANK_NO_REKENING,originalData.BANK_NO_REKENING);
        appendIfChanged(data,"BANK_ATAS_NAMA",formData.BANK_ATAS_NAMA,originalData.BANK_ATAS_NAMA);

        if (formData.image instanceof File) {
            data.append("image", formData.image);
        }

        for (const pair of data.entries()) {
          console.log(pair[0], "=", pair[1]);
        }
        
        const response = await axios.put(
          `${process.env.REACT_APP_API}/employee/${formData.KARYAWAN_ID}`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status === 200) {
          showSuccess("Karyawan berhasil diperbarui");
          onBack();
          if (onSuccess) onSuccess();
        } else {
          showError("Gagal memperbarui karyawan");
        }
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
      showError(error.response?.data?.message || "Terjadi kesalahan.");
    }
  };

  return (
    <form className="p-3" onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-4 mb-3">
          <label className="form-label">NIK KTP</label>
          <input type="text" className="form-control" name="NIK" value={formData.NIK} onChange={handleChange} required />
        </div>

        <div className="col-md-8 mb-3">
          <label className="form-label">Nama Lengkap</label>
          <input type="text" className="form-control" name="NAMA_LENGKAP" value={formData.NAMA_LENGKAP} onChange={handleChange} required />
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label">Agama</label>
          <select className="form-select" name="AGAMA" value={formData.AGAMA} onChange={handleChange} required>
            <option value="" disabled>Pilih</option>
            <option value="ISLAM">Islam</option>
            <option value="PROTESTAN">Protestan</option>
            <option value="KATOLIK">Katolik</option>
            <option value="HINDU">Hindu</option>
            <option value="BUDHHA">Buddha</option>
            <option value="KONGHUCU">Konghucu</option>
          </select>
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label">Jenis Kelamin</label>
          <select className="form-select" name="JENIS_KELAMIN" value={formData.JENIS_KELAMIN} onChange={handleChange} required>
            <option value="" disabled>Pilih</option>
            <option value="L">Laki-laki</option>
            <option value="P">Perempuan</option>
          </select>
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label">Tempat Lahir</label>
          <input type="text" className="form-control" name="TEMPAT_LAHIR" value={formData.TEMPAT_LAHIR} onChange={handleChange} required />
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label">Tanggal Lahir</label>
          <div className="input-group">
            <span className="input-group-text">
              <i className="bx bx-calendar"></i>
            </span>
            <Flatpickr
              name="TANGGAL_LAHIR"
              className="form-control"
              value={formData.TANGGAL_LAHIR}
              options={{ dateFormat: "Y-m-d" }}
              onChange={(selectedDates, dateStr) => {
                setFormData({
                  ...formData,
                  TANGGAL_LAHIR: dateStr,
                });
              }}
              required
            />
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Pendidikan Terakhir</label>
          <select className="form-select" name="PENDIDIKAN" value={formData.PENDIDIKAN} onChange={handleChange} required>
            <option value="" disabled>Pilih</option>
            <option value="SD">SD</option>
            <option value="SMP">SMP</option>
            <option value="SMA">SMA/SEDERAJAT</option>
            <option value="D3">D3</option>
            <option value="S1">S1</option>
            <option value="S2">S2</option>
          </select>
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">No HP</label>
          <input type="text" className="form-control" name="NO_HP" value={formData.NO_HP} onChange={handleChange} required />
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Email</label>
          <input type="email" className="form-control" name="EMAIL" value={formData.EMAIL} onChange={handleChange} />
        </div>

        <div className="col-md-12 mb-3">
          <label className="form-label">Alamat</label>
          <textarea className="form-control" name="ALAMAT" value={formData.ALAMAT} onChange={handleChange} required></textarea>
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Jabatan</label>
          <select className="form-select" name="JABATAN" value={formData.JABATAN} onChange={handleChange} required>
            <option value="" disabled>Pilih</option>
            <option value="Direksi">Direksi</option>
            <option value="General Manager">General Manager</option>
            <option value="Manager">Manager</option>
            <option value="Assistant Manager">Assistant Manager</option>
            <option value="Supervisor">Supervisor</option>
            <option value="Senior Staff">Senior Staff</option>
            <option value="Staff">Staff</option>
            <option value="Trainee / Intern">Trainee / Intern</option>
          </select>
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Departemen</label>
          <select className="form-select" name="DEPARTEMEN" value={formData.DEPARTEMEN} onChange={handleChange} required>
            <option value="" disabled>Pilih</option>
            <option value="Direksi">Direksi</option>
            <option value="Marketing">Marketing</option>
            <option value="Front Office">Front Office</option>
            <option value="Back Office">Back Office</option>
            <option value="Housekeeping">Housekeeping</option>
            <option value="Food & Beverage">Food & Beverage</option>
            <option value="HRD">HRD</option>
            <option value="Engineering">Engineering</option>
          </select>
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Tanggal Masuk</label>
          <div className="input-group">
            <span className="input-group-text">
              <i className="bx bx-calendar"></i>
            </span>
            <Flatpickr
              name="TANGGAL_MASUK"
              className="form-control"
              value={formData.TANGGAL_MASUK}
              options={{ dateFormat: "Y-m-d" }}
              onChange={(selectedDates, dateStr) => {
                setFormData({
                  ...formData,
                  TANGGAL_MASUK: dateStr,
                });
              }}
              required
            />
          </div>
        </div>

        {mode === "edit" && (
          <div className="col-md-4 mb-3">
            <label className="form-label">Tanggal Keluar</label>
            <div className="input-group">
              <span className="input-group-text">
                <i className="bx bx-calendar"></i>
              </span>
              <Flatpickr
                name="TANGGAL_KELUAR"
                className="form-control"
                value={formData.TANGGAL_KELUAR}
                options={{ dateFormat: "Y-m-d" }}
                onChange={(selectedDates, dateStr) => {
                  setFormData({
                    ...formData,
                    TANGGAL_KELUAR: dateStr,
                  });
                }}
                required
              />
            </div>
          </div>
        )}

        <div className="col-md-4 mb-3">
          <label className="form-label">Status Karyawan</label>
          <select className="form-select" name="STATUS_KARYAWAN" value={formData.STATUS_KARYAWAN} onChange={handleChange} required>
            <option value="" disabled>Pilih</option>
            <option value="Tetap">Tetap</option>
            <option value="Kontrak">Kontrak</option>
            <option value="Resign">Resign</option>
          </select>
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">No BPJS Kesehatan</label>
          <input type="text" className="form-control" name="NO_BPJS_KES" value={formData.NO_BPJS_KES} onChange={handleChange} />
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">No BPJS Ketenagakerjaan</label>
          <input type="text" className="form-control" name="NO_BPJS_KETENAGAKERJAAN" value={formData.NO_BPJS_KETENAGAKERJAAN} onChange={handleChange} />
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Kontak Darurat (Nama)</label>
          <input type="text" className="form-control" name="KONTAK_DARURAT_NAMA" value={formData.KONTAK_DARURAT_NAMA} onChange={handleChange} />
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Kontak Darurat (No HP)</label>
          <input type="text" className="form-control" name="KONTAK_DARURAT_HP" value={formData.KONTAK_DARURAT_HP} onChange={handleChange} />
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Nama Bank</label>
          <input type="text" className="form-control" name="BANK_NAMA" value={formData.BANK_NAMA} onChange={handleChange} />
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">No Rekening Bank</label>
          <input type="text" className="form-control" name="BANK_NO_REKENING" value={formData.BANK_NO_REKENING} onChange={handleChange} />
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Atas Nama Rekening</label>
          <input type="text" className="form-control" name="BANK_ATAS_NAMA" value={formData.BANK_ATAS_NAMA} onChange={handleChange} />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Foto</label>
          <input type="file" className="form-control" id="image" name="image" onChange={handleChange} required={mode === "add"}/>
        </div>
      </div>

      <button type="submit" className="btn btn-primary">
        {mode === "edit" ? "Update" : "Simpan"}
      </button>
      <button type="button" class="btn btn-secondary m-2" onClick={onBack}>
        Back
      </button>
    </form>
  );
}
